const routes = [
  {
    path: '/error',
    component: () => import('pages/errors/AuthFailPage.vue'),
  },

  {
    path: '/access-denied',
    component: () => import('pages/errors/AccessDeniedPage.vue'),
  },

  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    meta: {
      requiresAuth: true,
      hubPermission: 'SATISFACTION_SURVEY_VIEW',
    },
    children: [
      {
        path: '',
        component: () => import('pages/IndexPage.vue'),
      },
    ],
  },

  {
    path: '/popup-messages',
    component: () => import('pages/popupMessages/PopupMessagesPage.vue'),
    meta: {
      requiresAuth: true,
      hubPermission: 'POPUP_MESSAGE_VIEW',
    },
  },

  {
    path: '/customer-service',
    component: () => import('pages/customer-service/CustomerServiceCenterPage.vue'),
    meta: {
      requiresAuth: true,
      hubPermission: 'CUSTOMER_SERVICE_CENTER_VIEW',
    },
  },

  {
    path: '/news-interest',
    component: () => import('pages/communication/NewsPage.vue'),
    meta: {
      requiresAuth: true,
      hubPermission: 'INTEREST_NEWS_VIEW',
    },
  },

  {
    path: '/collection-points',
    component: () => import('pages/communication/CollectionPointsPage.vue'),
    meta: {
      requiresAuth: true,
      hubPermission: 'NOTICE_POINTS_VIEW',
    },
  },

  {
    path: '/faqs',
    component: () => import('pages/faq/FaqPage.vue'),
    meta: {
      requiresAuth: true,
      hubPermission: 'FAQ_VIEW',
    },
  },

  {
    path: '/app-news',
    component: () => import('pages/appNews/AppNewsPage.vue'),
    meta: {
      requiresAuth: true,
      hubPermission: 'APP_NEWS_VIEW',
    },
  },

  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
